







































































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import {
  BaseIcon,
  BaseButton,
  TypeDisplay,
  TypeOverline,
  TypeBody,
  FancyIcon,
} from '@bambeehr/pollen';

interface IItem {
  iconVariant: string;
  title: string;
  body: string;
  linkText: string;
  link: string;
}

export default defineComponent({
  name: 'BaseFeatureSummary',
  components: {
    BaseIcon,
    BaseButton,
    TypeDisplay,
    TypeBody,
    TypeOverline,
    FancyIcon,
  },
  props: {
    background: {
      type: String,
    },
    heading: {
      type: String,
    },
    headingColorVariant: {
      type: String,
    },
    title: {
      type: String,
    },
    isDescriptionRequired: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    description: {
      type: String,
    },
    featureItems: {
      type: Array as PropType<Array<IItem>>,
    },
    isFeatureItemButtonRequired: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    collapseBottomPadding: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const backgroundColor = computed(() => {
      switch (props.background) {
        case 'grey':
          return 'bg-grayBackgroundWeak';
        case 'purple-gradient':
          return 'bg-purple-gradient';
        default:
          return '';
      }
    });

    const isContentsEmpty = computed(() => {
      return props.heading === '' && props.title === '';
    });

    const doesHeadingExist = computed(() => {
      return props.heading !== '';
    });

    const bottomPadding = computed(() => {
      return props.collapseBottomPadding ? '' : 'pb-14 lg:pb-16';
    });

    const headingColor = computed(() => {
      switch (props.headingColorVariant) {
        case 'light-blue':
          return 'text-secondaryBrandDefault';
        case 'purple':
          return 'text-basePrimary';
        default:
          return '';
      }
    });

    const showBackgroundImage = computed(() => {
      if (props.background === 'purple-gradient') {
        return 'bg-feature-summary';
      }

      return '';
    });

    return {
      backgroundColor,
      isContentsEmpty,
      doesHeadingExist,
      bottomPadding,
      headingColor,
      showBackgroundImage,
    };
  },
});
